import { FileUploadService } from '../../files/FileUploadService'
import { OperationContext, OperationSpec } from './OperationContext'
import { RunnableOperation } from './RunnableOperation'

export class RunnableFileUpload extends RunnableOperation {
  private fileUploadService: FileUploadService | null = null
  private abortController: AbortController | null = null

  constructor(spec: OperationSpec) {
    super(spec)
    this.abortController = new AbortController()
  }

  async defineRequest(context: OperationContext): Promise<void> {
    super.defineRequest(context)
    const isEncryptedZone = !!this.userOpSpec.isEncryptedZone
    console.log(
      '🚀 ~ RunnableFileUpload ~ defineRequest ~ isEncryptedZone:',
      isEncryptedZone
    )

    return Promise.resolve()
  }
  async execute(): Promise<void> {
    this.setStatus('running')
    try {
      this.fileUploadService = new FileUploadService()
      this.fileUploadService.onProgressUpdate = (progress: number) => {
        this.setProgress(progress)
      }
      await this.fileUploadService.uploadFile(
        this.spec,
        this.abortController?.signal
      )
      this.setStatus('completed')
    } catch (error) {
      if ((error as Error).name === 'AbortError') {
        this.setStatus('aborted')
      } else {
        this.setStatus('error')
        console.error("Errore durante l'upload del file:", error)
        throw error
      }
    }
  }

  abort(): void {
    if (this.abortController) {
      this.abortController.abort()
    }
    if (this.fileUploadService) {
      this.fileUploadService.abortUpload()
    }
    super.abort()
  }
}
